import {LinkProps} from 'next/link';

export type NextLinkType = LinkProps;
export type CommonLinkType = NextLinkType;
export type CommonLinkReactElementType = React.ElementType<NextLinkType>;

export const DefaultLink = (props: NextLinkType) => {
	// link content passed via props, so no need to lint here

	return <a {...props} href={(props.href || '') as string} />;
};
